import React from "react";

import "./Content.scss";

import { reportTypes } from "../../store/reducers/reports";
import AnalyzeSegments from "./Content/Segments";
import CompareStores from "./Content/Stores";
import DailyPattern from "./Content/DailyPatterns";
import RecentTrends from "./Content/RecentTrends";
import StoreImages from "./Content/Images";

const ReportsContent = (props) => {
  const {
    type,
    stores,
    selectedStores,
    selectedAttributes,
    storeStats,
    dailyPatterns,
    recentTrends,
    recentTrendsStats,
  } = props;

  const filteredStoreStats = Object.keys(storeStats)
    .filter((k) => selectedAttributes.includes(k))
    .reduce((obj, key) => {
      obj[key] = Object.keys(storeStats[key])
        .filter((k) => ["min", "max", "type"].includes(k))
        .reduce((obj, key2) => {
          obj[key2] = storeStats[key][key2];
          return obj;
        }, {});
      return obj;
    }, {});

  return type === reportTypes.analyzeSegments.value ? (
    <AnalyzeSegments />
  ) : (
    <div className="reports-content">
      <div className="reports-chart">
        {type === reportTypes.compareStores.value &&
          selectedStores.length > 1 &&
          selectedAttributes.length > 0 && (
            <CompareStores
              storeStats={filteredStoreStats}
              stores={stores.filter((s) => selectedStores.includes(s.ID))}
              selectedAttributes={selectedAttributes}
            />
          )}
        {type === reportTypes.analyzeDailyPatterns.value &&
          selectedStores.length > 0 &&
          selectedAttributes.length > 0 && (
            <DailyPattern
              stores={dailyPatterns.filter((p) =>
                selectedStores.includes(p.ID)
              )}
              selectedAttributes={selectedAttributes}
            />
          )}
        {type === reportTypes.analyzeRecentTrends.value &&
          selectedStores.length > 0 &&
          selectedAttributes.length > 0 && (
            <RecentTrends
              stores={recentTrends.filter((p) => selectedStores.includes(p.ID))}
              selectedAttributes={selectedAttributes}
              recentTrendsStats={recentTrendsStats}
            />
          )}
      </div>
      <StoreImages
        stores={stores.filter((s) => selectedStores.includes(s.ID))}
      />
    </div>
  );
};

export default React.memo(ReportsContent);
